import { SVGProps } from '@components/Icon/types';

export const ArrowSort = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(5.7, 3)">
      <path
        d="M11.1486 11.1486C11.4681 10.8291 11.9873 10.8291 12.3068 11.1486C12.6259 11.468 12.6259 11.9864 12.3068 12.3058L6.8517 17.7609C6.53224 18.0799 6.01387 18.08 5.69447 17.7609L0.240373 12.3058C-0.0791362 11.9863 -0.0791362 11.4681 0.240373 11.1486C0.559889 10.8291 1.07811 10.8291 1.3976 11.1486L6.27358 16.0236L11.1486 11.1486ZM5.69447 0.239396C6.01397 -0.0797196 6.5323 -0.0798777 6.8517 0.239396L12.3058 5.69447C12.6252 6.01399 12.6253 6.53222 12.3058 6.8517C11.9863 7.17104 11.468 7.17106 11.1486 6.8517L6.2726 1.97572L1.3976 6.8517C1.07809 7.17121 0.558906 7.17121 0.239397 6.8517C-0.0798774 6.5323 -0.0797205 6.01397 0.239397 5.69447L5.69447 0.239396Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'arrow-sort';
